import defineComponent from 'flight';

function SearchTracking() {
    this._trackSearch = function (evt, payload) {

        let label = payload.suggestionType;

        this.trigger(document, 'analytics:track-event', {
            category: 'Search box',
            action: 'Navigation',
            label: label
        });
    };

    this.after('initialize', function () {
        this.on(document, 'ui:search-suggestion:before-search', this._trackSearch);
    });
}

module.exports = defineComponent.component(SearchTracking);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/search-tracking.js